<template>
    <v-layout fill-height column class="pt-4">
        <v-flex class="text-xs-center headline primary--text">
            Acesso bloqueado através do SmartLock
        </v-flex>
        <v-flex class="subheading text-xs-center grey--text text--darken-2 font-weight-medium">
            Clique no cadeado ao canto superior direito da tela para desbloquear
        </v-flex>
    </v-layout>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
